import http from '@/communication/AuthConnection'

export default async ({ commit }, {
  pativo,
  factor = 1,
  lab = null,
  startDate = null,
  endDate = null,
  onlyAssociated = null,
  result = null,
  guaranted = null,
  updateRankingDate = null,
  winnerDistributor = null,
  secondDistributor = null,
  thirdDistributor = null,
  skip = 0,
  limit = 40 }) => {
  const { data } = await http.post(`/v1/stock/item-history`, {
    pativo,
    factor,
    lab,
    onlyAssociated,
    result,
    guaranted,
    startDate,
    endDate,
    updateRankingDate,
    winnerDistributor,
    secondDistributor,
    thirdDistributor,
    skip,
    limit
  })

  if (data) {
    return { eventItems: data.eventItems, countDocuments: data.countDocuments }
  } else {
    return Promise.reject(Error('Não foi possível carregar a listagem'))
  }
}



// WEBPACK FOOTER //
// ./src/brain/record/stock/item-history/index.js